module.exports = __webpack_public_path__ + "img/ico_fb.f0b8fef6.svg";